"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Goal_Target = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Range_1 = require("./RTTI_Range");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Ratio_1 = require("./RTTI_Ratio");
var RTTI_Duration_1 = require("./RTTI_Duration");
exports.RTTI_Goal_Target = t.recursion('IGoal_Target', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        measure: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        detailQuantity: RTTI_Quantity_1.RTTI_Quantity,
        detailRange: RTTI_Range_1.RTTI_Range,
        detailCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        detailString: t.string,
        _detailString: RTTI_Element_1.RTTI_Element,
        detailBoolean: t.boolean,
        _detailBoolean: RTTI_Element_1.RTTI_Element,
        detailInteger: t.number,
        _detailInteger: RTTI_Element_1.RTTI_Element,
        detailRatio: RTTI_Ratio_1.RTTI_Ratio,
        dueDate: t.string,
        _dueDate: RTTI_Element_1.RTTI_Element,
        dueDuration: RTTI_Duration_1.RTTI_Duration
    });
});
//# sourceMappingURL=RTTI_Goal_Target.js.map